module.exports = __webpack_public_path__ + "static/view_4-569973ab5e1bac55ab71c2c16d4b5e2a.jpg";